import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(_callee);

export default function _callee(start, stop, step) {
  var i,
      n,
      _args = arguments;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          start = +start;
          stop = +stop;
          step = (n = _args.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
          i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0;

        case 4:
          if (!(++i < n)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return start + i * step;

        case 7:
          _context.next = 4;
          break;

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}